import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromReducer from '../reducers/index';

@Injectable()
export class ClientKeyInterceptor implements HttpInterceptor {
  activeFund: any;

  constructor(private store: Store<fromReducer.State>) {
    this.store.pipe(select(fromReducer.selectCurrentFundState)).subscribe(el => this.activeFund = el);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(this.activeFund?.key) {
      request = request.clone({ 
        headers: request.headers
        .set('x-ptg-client-id', this.activeFund?.id)  
        .set('x-ptg-client-key', this.activeFund?.key)
      });
    }

    return next.handle(request);
  }
}
